import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Colonne 1 - Logo */}
          <div className="footer-col footer-logo-col">
            <img src="/assets/IMG/logo_transparent.png" alt="BEtalented" className="footer-logo" />
            <p className="footer-tagline">Talents Africains, standards mondiaux</p>
          </div>

          {/* Colonne 2 - Contact */}
          <div className="footer-col">
            <h4>CONTACT</h4>
            <ul className="footer-contact">
              <li>Cocody 2 Plateaux Cité AXA</li>
              <li>+225 07 07 07 77 77</li>
              <li>info@fondationbetalented.org</li>
              <li>https://fondationbetalented.org</li>
            </ul>
          </div>

          {/* Colonne 3 - Liens utiles */}
          <div className="footer-col">
            <h4>LIENS UTILES</h4>
            <ul className="footer-links">
              <li><Link to="/programmes">PROGRAMMES</Link></li>
              <li><Link to="/faire-un-don">FAIRE UN DON</Link></li>
              <li><Link to="/inscription">S'INSCRIRE</Link></li>
              <li><Link to="/partenaires">ÊTRE PARTENAIRE</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div>

          {/* Colonne 4 - Newsletter + Réseaux */}
          <div className="footer-col">
            <p className="newsletter-text">Restez informé de nos dernières actualités et opportunités</p>
            <form className="newsletter-form" onSubmit={handleSubmit}>
              <input 
                type="email" 
                placeholder="Votre adresse"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit">ENVOYER</button>
            </form>
            <div className="social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                </svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                  <path d="M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33A2.78 2.78 0 003.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.25 29 29 0 00-.46-5.33z"/>
                  <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="#111"/>
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" fill="#111"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="#111" strokeWidth="2"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} BEtalented. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
